import { Flex } from "@chakra-ui/react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RemoteRenderingBackchannel } from "../../../pages";

// Any URI scheme is allowed for a callback target: it is opened on the remote
// machine and native apps there register custom schemes (e.g. `myapp://callback`).
// `catch` keeps a malformed value out of the search error boundary so the page
// can render its own "no valid callback" message instead.
const callbackTarget = z.url().optional().catch(undefined);

const remoteRenderingBackchannelQueryParamsSchema = z.object({
  // The canonical name for the callback target. See `backchannelTargetParams`:
  // Autodesk overwrites a callback param named exactly `redirect_uri` with its
  // own base URL, so the target rides under a name no identity provider touches.
  cb: callbackTarget,
  // The legacy name, still honored for callers that predate `cb`.
  redirect_uri: callbackTarget,
});

export const Route = createFileRoute(
  "/_authenticated/session/remote-rendering-node-backchannel",
)({
  component: () => (
    <Flex flexGrow={1} alignSelf={"center"} alignItems={"center"}>
      <RemoteRenderingBackchannel />
    </Flex>
  ),
  validateSearch: remoteRenderingBackchannelQueryParamsSchema,
});
